/**
 * Empty state block (PRD Global States).
 *
 * Which empty state to show is always decided by a server discriminant (`neverScraped`,
 * `state:'empty'` + `reason`, zero rows) — this component only paints one (§12.5 rule 5).
 */

import type { ReactNode } from 'react';
import { cx } from './cx';

export type EmptyStateProps = {
  title: string;
  /** Server-provided `reason` where one exists; otherwise static UI copy. */
  description?: ReactNode;
  /** CTA, e.g. "Scrape now" or "Clear filters". */
  action?: ReactNode;
  icon?: ReactNode;
  className?: string;
};

export function EmptyState({ title, description, action, icon, className }: EmptyStateProps) {
  return (
    <div className={cx('empty-state', className)}>
      {icon ? <div aria-hidden="true">{icon}</div> : null}
      <p className="empty-state__title">{title}</p>
      {description ? <p className="empty-state__description">{description}</p> : null}
      {action ? <div className="empty-state__action">{action}</div> : null}
    </div>
  );
}

export default EmptyState;
